<div #container>
    <div class="card-header">
        <h4 class="card-header-title">
            <img src="assets/images/icons/co2.png" width="20px" class="me-2">
            <span class="ml-2 notranslate">CO<sub>2</sub></span>
        </h4>
        <app-chart-download-button *ngIf="!showInReport" [element]="container"></app-chart-download-button>
    </div>
    <div class="card-body pt-0">
        <p *ngIf="coolingWithoutEmissionFactorGj > 0" class="small text-warning mb-2" role="status">
            <span translate>Cooling CO2 factor missing; subtotal excludes</span>
            <span class="notranslate">&nbsp;{{ coolingWithoutEmissionFactorGj | number:'1.0-3' }} GJ.</span>
        </p>
        <app-doughnut-chart class="chart chart-appended h-100 d-flex align-items-center justify-content-center"
                            [doughnutText]="(totalCo2 | number) + ' tn'"
                            [dataProvider]="dataProvider" [height]="300"
                            [animationDuration]="showInReport ? 0 : 1000"
                            [withCircumference]="true"></app-doughnut-chart>
    </div>
</div>
